export default __webpack_public_path__ + "static/media/data_setting_9.476f5795.png";